webpackJsonp([9347362237655822000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/index.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"webpack": {
				"html": "<div class=\"gatsby-highlight\">\n      <pre class=\"language-javascript\"><code><span class=\"token keyword\">var</span> webpackConfig <span class=\"token operator\">=</span> <span class=\"token punctuation\">{</span>\n  plugins<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>\n    <span class=\"token keyword\">new</span> <span class=\"token class-name\">BundleCopWebpackPlugin</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n      projectKey<span class=\"token punctuation\">:</span> <span class=\"token string\">'ahniemooT6aiH1ho2shu5Eng7uu6ke'</span><span class=\"token punctuation\">,</span>\n      bundleSet<span class=\"token punctuation\">:</span> <span class=\"token string\">'3463934343322349'</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n  <span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">;</span>\n</code></pre>\n      </div>"
			},
			"cli": {
				"html": "<div class=\"gatsby-highlight\">\n      <pre class=\"language-bash\"><code>$ bundlecop submit \\\n    --projectKey ahniemooT6aiH1ho2shu5Eng7uu6ke \\\n    --bundleset 3463934343322349 \\\n    ./build/\n</code></pre>\n      </div>"
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---index-21bc8c680a2f60eaac9f.js